import { render, staticRenderFns } from "./shop_get_order.vue?vue&type=template&id=06b47656&scoped=true&"
import script from "./shop_get_order.vue?vue&type=script&lang=js&"
export * from "./shop_get_order.vue?vue&type=script&lang=js&"
import style0 from "./shop_get_order.vue?vue&type=style&index=0&id=06b47656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b47656",
  null
  
)

export default component.exports